import type { FC } from 'react';
import type { AllStrapiProduct } from '../../../../@types/gql/products-listing';
import ProductCard from './card';

interface ProductListingByCategoryProps {
  products: AllStrapiProduct;
}

const ProductListingByCategory: FC<ProductListingByCategoryProps> = ({
  products,
}) => {


  console.log("products,subCategory",products);

  return (
    <div className="px-6 mt-6 max-md:px-0">
      <div className="grid grid-cols-3 gap-6 max-xl:grid-cols-3 max-xl:gap-3 max-lg:grid-cols-2 max-lg:gap-2 max-sm:grid-cols-1 max-sm:gap-1">
        {products.nodes?.map(
          ({ Title, Slug, id, Description, Thumbnail, subCategory }) => {
            if (!subCategory) {
              return null;
            }
            return (
              <ProductCard
                description={Description}
                href={`/${subCategory.Category.Slug}/${subCategory.Slug}/${Slug}`}
                image={Thumbnail.url}
                key={id}
                name={Title}  
              />
            );
          },
        )}
      </div>   
         <div>

         {products.nodes?.map(
          ({subCategory },index) => {
            if (!subCategory?.VideoUrl) {
              return null;
            }
            {if (index === 0) {
              return <>
           
              <h2 className='text-4xl mb-6 mt-8 font-bold max-md:text-2xl max-md:mt-6'>Video:</h2>
              <div className="responsive-iframe-container">
                
              <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen frameBorder="0" src={subCategory.VideoUrl} />
            </div>
              </>
            }
            }
            return null;
          },
        )}
         </div>
    </div>
  );
};

export default ProductListingByCategory;
